<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex>
          <h1 style="display:inline-block;">Students</h1>
        </v-flex>
        <!-- <v-btn small color="primary">Create Student</v-btn> -->
      </v-layout>
    </v-container>

    <students-dashboard></students-dashboard>

    <v-container>
      <v-layout>
        <v-flex offset-xs1 xs10>
          <hr>
        </v-flex>
      </v-layout>
    </v-container>

    <students-results></students-results>

  </div>
</template>

<script>
  import StudentsDashboard from './StudentsDashboard';
  import StudentsResults from './StudentsResults';

  export default {
    components: {
      StudentsDashboard,
      StudentsResults
    },
    data() {
      return {};
    },
    created: function () {
      this.$store.dispatch("getAllStudents");
    }
  };
</script>